import SmtpSettingsService from './SmtpSettingsService';
import EmailTemplateService from './EmailTemplateService';
import EmailLogService from './EmailLogService';
import { renderTemplate } from '../utils/templateRenderer';
import { sanitizeHtml } from '../utils/emailSanitizer';

const validateSmtp = (settings) => {
  if (!settings.enabled) return 'SMTP is disabled.';
  if (!settings.host) return 'SMTP host is required.';
  if (!settings.port) return 'SMTP port is required.';
  if (!settings.from_email) return 'From email is required.';
  return '';
};

export default class EmailService {
  constructor() {
    this.smtpService = new SmtpSettingsService();
    this.templateService = new EmailTemplateService();
    this.logService = new EmailLogService();
  }

  sendTemplate({ templateKey, to, data = {}, entity = {} }) {
    const template = this.templateService.getByKey(templateKey);
    if (!template) {
      return this.logService.add({
        to,
        subject: 'Unknown template',
        template_key: templateKey,
        status: 'failed',
        error_message: `Template ${templateKey} not found.`,
        entity_type: entity.type,
        entity_id: entity.id
      });
    }
    const subject = renderTemplate(template.subject, data);
    const rawHtml = renderTemplate(template.html_body, data);
    const html = sanitizeHtml(rawHtml);
    const text = template.text_body ? renderTemplate(template.text_body, data) : '';
    return this.sendRaw({ to, subject, html, text, templateKey, entity });
  }

  sendRaw({ to, subject, html, text, templateKey, entity = {} }) {
    const smtp = this.smtpService.get();
    const validationError = validateSmtp(smtp);
    if (validationError) {
      return this.logService.add({
        to,
        subject,
        template_key: templateKey,
        status: 'failed',
        error_message: validationError,
        entity_type: entity.type,
        entity_id: entity.id
      });
    }

    return this.logService.add({
      to,
      subject,
      html_body: html,
      text_body: text,
      template_key: templateKey,
      status: 'sent',
      sent_at: new Date().toISOString(),
      entity_type: entity.type,
      entity_id: entity.id
    });
  }
}
